import { useEffect, useState } from 'react'
import * as S from './styled'

import MHeader from '@/components/MHeader'
import GoldBanner from '@/components/gold/GoldBanner'
import GoldNews from '@/components/gold/GoldNews'
import GoldNoticePopup from '@/components/gold/GoldNoticePopup'
import MGameList from '@/components/MGameList'
import MFooter from '@/components/MFooter'
import MHistory from '@/components/MHistory'
import api from '@/core/services/api'


export default function Mobile() {
  const [scrollNotice, setScrollNotice] = useState(null)

  useEffect(() => {
    api.get('/site/scroll')
      .then((res) => {
        const { contents, is_inspection_visible } = res.data.content
        if (is_inspection_visible && contents) {
          setScrollNotice(contents)
        }
      })
      .catch(console.error)
  }, [])

  return (
    <S.GoldWrap>

      <MHeader />

      {/* ver2(gold) 모바일 순서: 헤더 → 배너 → 공지 띠 → 게임사 판(3열) → 하단 */}
      <S.GoldBody>
        <GoldBanner mobile />
        <S.GoldNewsWrap><GoldNews mobile /></S.GoldNewsWrap>
        <MGameList />
        <MFooter />
        <MHistory />
      </S.GoldBody>
      <GoldNoticePopup mobile />

      {scrollNotice && (
        <S.ScrollNotice>
          <S.ScrollNoticeTrack>{scrollNotice}</S.ScrollNoticeTrack>
        </S.ScrollNotice>
      )}

    </S.GoldWrap>
  )
}
